import { InsuranceProducts } from "../../constants";
import useAppSelector from "../../hooks/useAppSelector";
function getV2HeaderText(numOfDrivers, numOfVehicles) {
    var text = [];
    if (numOfDrivers) {
        text.push("".concat(numOfDrivers, " Driver").concat(numOfDrivers > 1 ? "s" : ""));
    }
    if (numOfVehicles) {
        text.push("".concat(numOfVehicles, " Vehicle").concat(numOfVehicles > 1 ? "s" : ""));
    }
    return text.join(", ");
}
export default function useResultsHeaderText() {
    return useAppSelector(function (state) {
        var isHome = state.applicant.insuranceProduct === InsuranceProducts.Home;
        if (isHome) {
            return [
                state.unlinkedApplication.homeowners.address1,
                state.unlinkedApplication.homeowners.address2,
            ].join(" ");
        }
        return getV2HeaderText(state.unlinkedApplication.auto.drivers.length, state.unlinkedApplication.auto.vehicles.length);
    });
}
